import React from 'react';
import { createPortal } from 'react-dom';
import { Toast, type ToastProps } from './Toast';

interface ToastContainerProps {
  toasts: ToastProps[];
  onDismiss: (id: string) => void;
}

export const ToastContainer: React.FC<ToastContainerProps> = ({
  toasts,
  onDismiss,
}) => {
  // Create portal to render toasts at the top level
  return createPortal(
    <div className="fixed inset-0 pointer-events-none z-[9999]">
      <div className="absolute top-4 right-4 flex flex-col space-y-3 items-end max-w-sm w-full pr-4">
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            {...toast}
            onDismiss={onDismiss}
          />
        ))}
      </div>
    </div>,
    document.body
  );
};
